import $ from 'jquery';
import 'slick';
import 'magnific-popup/dist/jquery.magnific-popup';
import { 
    slickCommonOptions 
} from '../../scripts/config';

/**
 * GalleryV5 widget configs
 */
const galleryV5Semantics = {
    'mainWrapClass': 'gallery-v5',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'commonPluginOptionsAttribute': 'data-common-plugin-options',
    'sliderElementClass': 'gallery-v5__track',
    'sliderCurrentImage': 'gallery-v5__current-image',
    'dotsElementClass': 'gallery-v5__track-element',
    'dotsActiveClass': 'gallery-v5__track-element_active',
    'overlayElementClass': 'gallery-v5__overlay',
    'sliderNavElementClass': 'gallery-v5__slider-nav',
    'pageControlElementClass': 'gallery-v5__page-controller',
    'popupClassImage': 'gallery-v5__img-preview',
    'popupMainClass': 'gallery-v5__popup',
    'itemImageClass': 'gallery-v5__slide_wrapper',
};

/**
 * GalleryV5 initializer
 */
$(function () {
    if ($(`.${galleryV5Semantics.mainWrapClass}`).length === 0) {
        return false;
    }

    window.widgets.galleryV5 = new GalleryV5();

    window.widgets.galleryV5.initAll();

});

class GalleryV5 {
    // not install @babel/plugin-proposal-class-properties
    // init properties in constructor
    constructor() {
        this.pluginInstances = {};
        this.isMouseOver = false;
    }

    /**
     * Контекст поиска в виде html-элемента
     * @param jQuery context
     */
    initAll(
        context
    ) {
        let self = this;
        let els = null;
        if (context) {
            els = context.find(`.${galleryV5Semantics.mainWrapClass}`);
        } else {
            els = $(`.${galleryV5Semantics.mainWrapClass}`);
        }

        /**
         * Checking other instances
         */
        els.each((index, el) => {
            let objectElement = $(el);
            let isInitialized =
                (objectElement.attr(`${galleryV5Semantics.isInitializedAttribute}`) === 'true');
            if (!isInitialized) {
                window.widgets.galleryV5.registerInstance(objectElement);
                window.widgets.galleryV5.registerCustomDots(objectElement);
                window.widgets.galleryV5.registerCustomSlickEvent(objectElement);
                window.widgets.galleryV5.registerPageControl(objectElement);
                window.widgets.galleryV5.registerEvents(objectElement);
            }
        });
    }

    /**
     * Register all events on slider
     * @param JQuery el
     * @throws
     */
    registerEvents(el) {

        // запуск переинициализации slick-галереи 
        // при загрузке первого изображения
        // el.find(`.${galleryV5Semantics.itemImageClass}:first img`).on(
        //     'load', 
        //     function(e) {
        //         window.widgets.galleryV5.initAll();
        //     }
        // );

        // запуск lazySizes-плагина до смены основного слайдера
        // el.find(`.${galleryV5Semantics.sliderCurrentImage}`).on(
        //     'beforeChange', 
        //     function(event, slick, currentSlide, nextSlide) {
        //         let nextSlideEl = el.find(`.${galleryV5Semantics.itemImageClass}[data-slick-index=${nextSlide}]`);
        //         let imgElem = null;
        //         if (nextSlideEl) {
        //             imgElem = nextSlideEl.find('.lazyload');
        //         }
        //         if (!imgElem) {
        //             return true;
        //         }
        //         lazySizes.loader.unveil(imgElem[0]);
        //     }
        // );
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerInstance(el) {
        let instanceId =
            el.attr(`${galleryV5Semantics.instanceIdAttribute}`) || false;
        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }
        let commonPluginOptions =
            el.data(
                `${galleryV5Semantics.commonPluginOptionsAttribute}`.replace('data-', '')
            ) || {};

        let asNavSelector = `.${galleryV5Semantics.mainWrapClass}[${galleryV5Semantics.instanceIdAttribute}="${instanceId}"] .${galleryV5Semantics.sliderNavElementClass}`;

        let asMainSelector = `.${galleryV5Semantics.mainWrapClass}[${galleryV5Semantics.instanceIdAttribute}="${instanceId}"] .${galleryV5Semantics.sliderCurrentImage}`;

        let pluginOptions = Object.assign({},
            slickCommonOptions,
            commonPluginOptions,
            {
                arrows: false,
                variableWidth: false,
                mobileFirst: true,
                swipeToSlide: true,
                centerMode: false,
                // adaptiveHeight: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                speed: 0,
                focusOnSelect: true,
                asNavFor: asNavSelector
            });

        let pluginOptionNav = {
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: asMainSelector,
            dots: false,
            arrows: false,
            centerMode: false,
            focusOnSelect: true,
            speed: 0,
            centerPadding: '10px',
            spaceBetween: 10,
        };
        el.show();
        try {
            // TODO[dependDetected]: slick plugin
            let slick = $(asMainSelector).slick(pluginOptions);
            let navSlider = $(asNavSelector).slick(pluginOptionNav);

            el.attr(`${galleryV5Semantics.isInitializedAttribute}`, true);
            window.widgets.galleryV5.pluginInstances[instanceId] = slick;

            window.widgets.galleryV5.registerOverEvent(navSlider, slick);
        } catch (e) {
            //el.hide();
            throw e;
        }
    }

    registerPageControl(el) {
        let instanceId =
            el.attr(`${galleryV5Semantics.instanceIdAttribute}`) || false;

        el.on('mouseenter', `.${galleryV5Semantics.overlayElementClass}`, function (event) {
            event.preventDefault();
            let index = $(this).index();
            el.find('.' + galleryV5Semantics.sliderCurrentImage).slick('slickGoTo', index);
        });

        el.on('click', `.${galleryV5Semantics.overlayElementClass}`, function (event) {
            event.preventDefault();
            const index = $(this).index();
            let items = [];
            // собираем галлерею
            el.find(`.${galleryV5Semantics.itemImageClass}`).filter(function() {
                  return !$(this).closest('.slick-cloned').length;
            }).each(function () {
                const src = $(this).find('img').attr('src');
                const title = $(this).find('img').attr('alt') || '';

                if (src) {
                    items.push({
                        src: src,
                        title: title,
                        type: 'image'
                    });
                }
            });

            if (!items || !items.length) {
                console.warn('No popup items found');
                return;
            }
            $.magnificPopup.open({
                items: items,
                gallery: {
                    enabled: true,
                    tCounter: '%curr% из %total%',
                },
                type: 'image',
                mainClass: galleryV5Semantics.popupMainClass,
                image: {
                    verticalFit: true,
                    titleSrc: 'title'
                }
            }, index);
        });
        //Maybe use it with option parameter in future
        /*el.on('mouseleave', `.${galleryV5Semantics.pageControlElementClass}`, function (event) {
            event.preventDefault();
            el.find('.' + galleryV5Semantics.sliderCurrentImage).slick('slickGoTo', 0);
        });*/
    }

    registerOverEvent(navSlider, mainSlider) {
        // navSlider.find('.slick-slide').on('mouseenter', (e) => {
        //     mainSlider.slick('slickGoTo', $(this).data('slick-index'));
        //     this.isMouseOver = true;
        // });

        // navSlider.find('.slick-slide').on('mouseleave', (e) => {
        //     this.isMouseOver = false;
        // });
    };

    registerCustomDots(el) {
        el.find('.' + galleryV5Semantics.dotsElementClass).on('click', function (e) {
            let index = $(this).index();
            el.find('.' + galleryV5Semantics.sliderCurrentImage).slick('slickGoTo', index);
        });
    }

    registerCustomSlickEvent(el) {
        el.find('.' + galleryV5Semantics.sliderCurrentImage).on('afterChange',  (event, slick, currentSlide) => {
            let customDots = el.find('.' + galleryV5Semantics.dotsElementClass);
            customDots.removeClass(galleryV5Semantics.dotsActiveClass);
            customDots.eq(currentSlide).addClass(galleryV5Semantics.dotsActiveClass);
        });
    }

    reInit(instanceId) {
        window.widgets.galleryV5.pluginInstances[instanceId].slick('unslick').slick('init');
    }

    reInitAll() {
        let instances = window.widgets.galleryV5.pluginInstances;
        for (let id in instances) {
            if (!instances.hasOwnProperty(id)) {
                continue;
            }
            instances[id].slick('unslick').slick('init');
        }
    }

    // /**
    //  * TODO[justMvp]: внедрить универсальное решение
    //  * для переинициализации любых дочерних js-плагинов
    //  * внутри родительских
    //  * @return void
    //  */
    reInitPlugins(
        timeout = 1000
    ) {
        setTimeout(() => {
            window.widgets.galleryV5.initAll();
        }, timeout);
    }
}